export default "__VITE_ASSET__Kn8ND9KO__"